import React from "react"

import Layout from "../components/Layout"
import SEO from "@/components/SEO"
import { StaticImage } from "gatsby-plugin-image"
import { routes } from "../utils/routes"

type PageProps = {
  data: any
}

const TaxEfficientGiving: React.FC<PageProps> = ({}) => (
  <Layout
    sectionOne={
      <>
        <div className="relative h-[67vh] md:min-h-[75vh]">
          <StaticImage
            src="../../static/images/_F7A5002.jpg"
            className="absolute inset-0 w-full h-full object-cover -z-50"
            alt="Tax Efficient Giving Header"
          />
          <div className="absolute inset-0 bg-[#131312]/50 -z-40"></div>

            <div className="container text-white h-[67vh] md:min-h-[75vh] flex items-center px-4">
              <div className="pl-2 md:pl-6 lg:pl-10 max-w-[1000px] translate-y-10 md:translate-y-16 lg:translate-y-20">
                <div className="pb-4">
                  <h1
                    className="text-left text-white text-[300%] sm:text-[400%] md:text-[531.25%] leading-[1] font-bold normal-case tracking-normal font-gilroy"
                  >
                    Tax Efficient Giving
                  </h1>
                  <div className="mt-5 h-[8px] sm:h-[10px] w-[200px] sm:w-[320px] bg-primary"></div>
                </div>
              </div>
            </div>
        </div>

        {/* Gold four-option bar below the fold */}
        <div className="bg-primary w-full h-[33vh] md:h-auto md:block">
          <div className="flex flex-col h-full w-full md:grid md:grid-cols-4 md:gap-0 md:items-stretch md:min-h-[84px]">
              <a href={routes.socialMobility()} className="flex-1 flex items-center justify-center px-4 text-center uppercase font-gilroy font-bold text-[#131312] border-b border-white text-[19px] leading-[32.3px] md:border-b-0 md:border-r md:px-2">
                Transformative Bursaries
              </a>
              <a href={routes.southWingDevelopment()} className="flex-1 flex items-center justify-center px-4 text-center uppercase font-gilroy font-bold text-[#131312] border-b border-white text-[19px] leading-[32.3px] md:border-b-0 md:border-r md:px-2">
                The South Wing
              </a>
              <a href={routes.pledge()} className="flex-1 flex items-center justify-center px-4 text-center uppercase font-gilroy font-bold text-[#131312] border-b border-white text-[19px] leading-[32.3px] md:border-b-0 md:border-r md:px-2">
                Sponsor a Paviour
              </a>
              <a href={routes.donate()} className="flex-1 flex items-center justify-center px-4 text-center uppercase font-gilroy font-bold text-[#131312] text-[19px] leading-[32.3px] md:px-2">
                Donate
              </a>
          </div>
        </div>
      </>
    }
  >
    <SEO title="Tax Efficient Giving" />
    <div className="container py-14">
      <div className="flex justify-center">
        <div className="flex flex-col gap-4 max-w-[700px]">
          <h3 className="mb-4 text-3xl normal-case font-gilroy font-bold">
            Gifts from UK tax payers are eligible for Gift Aid. <span className="text-primary">Higher rate tax
            payers can reclaim tax</span> against their giving, as illustrated below.
            Please contact the RBAI Foundation Director for further information.
          </h3>

          <div className="flex justify-center mt-6 lg:mt-8 overflow-x-auto">
            <img
              src="/images/tax%20giving%20table.png"
              className="block w-full max-w-4xl"
              style={{ width: "100%", height: "auto" }}
              alt="Tax Efficient Giving Table"
            />
          </div>

          <p className="mt-5 font-gilroy">
            <strong>INTERNATIONAL DONORS</strong>
          </p>
          <p className="font-gilroy">
            Donors in the USA can give tax efficiently via the British Schools
            and Universities Foundation (www.bsuf.org), ensuring they receive a
            501c receipt, whilst 100% of the gift reaches RBAI.
          </p>
          <p className="font-gilroy">
            Donors in other countries should contact the RBAI Foundation
            Director to discussed tax-efficient contributions.
          </p>
          <p>&nbsp;</p>
          <p className="font-gilroy">
            <strong>DONATING SHARES OR OTHER ASSETS</strong>
          </p>
          <p className="font-gilroy">
            RBAI can accept gifts of shares or assets including land.  Such
            gifts from UK tax payers will be exempt from Capital Gains Tax,
            whilst the donor can also claim Income Tax relief on the market
            value of qualifying shares at the point of gift.
          </p>
          <p className="font-gilroy">
            <span>
              By way of example, a 45% taxpayer gifts shares worth £10,000 to
              RBAI, which they purchased for £6,000.  Alongside saving 20%
              capital gains tax on the profit of £4,000, they can claim 45% tax
              relief on the total gift.  This equates to a total tax saving of
              £5,300, meaning the net cost of the gift to the donor is £4,700. 
              Source: <i>Charities Aid Foundation</i>
            </span>
            <span></span>
          </p>
        </div>
      </div>
    </div>
  </Layout>
)

export default TaxEfficientGiving
